import React, { useState } from "react";
import { db, storage } from "../../base";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink, faTrash } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

const ListPdf = ({ pdf, categorys, collection }) => {
  const [url, setUrl] = useState(pdf.url);
  const [showDelete, setShowDelete] = useState("inactive");
  const [selectCategory, setSelectCategory] = useState(pdf.category);
  const [showMessageUpdate, setShowMessageUpdate] = useState("notif inactive");
  const imgRef = storage.refFromURL(pdf.url);

  const deletePdf = () => {
    db.collection(collection).doc(pdf.id).delete();
    imgRef
      .delete()
      .then(() => {})
      .catch((error) => {
        console.log(error);
      });
  };

  const handleUpdate = () => {
    db.collection(collection).doc(pdf.id).set(
      {
        category: selectCategory,
      },
      { merge: true }
    );
    setShowMessageUpdate("notif active");
    setTimeout(() => {
      setShowMessageUpdate("notif inactive");
    }, 3000);
  };

  const handleShowDelete = () => {
    if (showDelete === "inactive") {
      setShowDelete("active");
    } else {
      setShowDelete("inactive");
    }
  };

  const optionsCategorys = categorys;

  const handleChangeSelectCategory = (newValue) => {
    setSelectCategory(newValue.label);
  };

  return (
    <li className="affiche-pdf">
      <a href={url} target="_blank" rel="noreferrer">
        <FontAwesomeIcon icon={faLink} />
        {pdf.name}
      </a>
      <Select
        className="select"
        name="category"
        placeholder={selectCategory}
        onChange={handleChangeSelectCategory}
        options={optionsCategorys}
      />
      <button className="button-update" onClick={handleUpdate}>
        Mettre à jour
      </button>
      <button className="trash" onClick={handleShowDelete}>
        <FontAwesomeIcon icon={faTrash} />
      </button>
      <div id="show-delete" className={showDelete}>
        <div className="title-buttons">
          <h2>Êtes-vous sûr de vouloir supprimer le fichier PDF {pdf.id}</h2>
          <button className="yes" onClick={deletePdf}>
            Oui
          </button>
          <button className="no" onClick={handleShowDelete}>
            Non
          </button>
        </div>
      </div>
      <div className={showMessageUpdate}>
        Mise à jour de <b>{pdf.name}</b> réussie.
      </div>
    </li>
  );
};

export default ListPdf;
